import { capitalizeAll } from '../../../../../libs/strings';

export function getCustomerDisplayName(customer) {
  if (!customer) {
    return '';
  }

  return [capitalizeAll(customer.first_name), capitalizeAll(customer.last_name)]
    .filter(Boolean)
    .join(' ');
}
